import { useState, useEffect } from 'react';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../services/firebase/config';

const SETTINGS_DOC = 'settings';
const SETTINGS_ID = 'branding';
const DEFAULT_LOGO = '/logo.png';

export const useLogoSettings = () => {
  const [logo, setLogo] = useState(DEFAULT_LOGO);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch logo from Firestore
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        setLoading(true);
        const docRef = doc(db, SETTINGS_DOC, SETTINGS_ID);
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists() && docSnap.data().logoUrl) {
          setLogo(docSnap.data().logoUrl);
        } else {
          // Default to public logo if not found
          setLogo(DEFAULT_LOGO);
        }
        setError(null);
      } catch (err) {
        console.warn('Warning: Could not fetch logo from Firestore:', err.message);
        // Silently fall back to default logo - don't throw error
        setLogo(DEFAULT_LOGO);
        setError(null); // Don't set error to avoid console noise for unauthenticated users
      } finally {
        setLoading(false);
      }
    };

    fetchLogo();
  }, []);

  // Update logo URL in Firestore
  const updateLogo = async (logoUrl) => {
    try {
      const docRef = doc(db, SETTINGS_DOC, SETTINGS_ID);
      await setDoc(docRef, { logoUrl }, { merge: true });
      setLogo(logoUrl);
      setError(null);
      return { success: true };
    } catch (err) {
      console.error('Error updating logo:', err);
      setError(err);
      return { success: false, error: err.message };
    }
  };

  return {
    logo: logo || DEFAULT_LOGO,
    loading,
    error,
    updateLogo
  };
};
